import StoreUtil from '@/store/StoreUtil'

export default {
  CURRENT_SCAN: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.scan,
    'currentScan'
  ),
  MATCH_RATE: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.scan,
    'matchRate'
  ),
  FINDINGS_BY_CATEGORY: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.scan,
    'findings'
  ),
  FINDINGS_FILTERED: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.scan,
    'findingsFiltered'
  ),
  RESUME_VARIABLES: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.scan,
    'variables'
  ),
  TITLE: StoreUtil.prefixModuleKeys(StoreUtil.moduleNames.scan, 'title'),
  IS_STARRED: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.scan,
    'isStarred'
  ),
  IS_FETCHING: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.scan,
    'isFetching'
  ),
  IS_EDITING_TITLE: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.scan,
    'isEditingTitle'
  ),
  SKILLS: StoreUtil.prefixModuleKeys(StoreUtil.moduleNames.scan, 'skills'),
  RESUME: StoreUtil.prefixModuleKeys(StoreUtil.moduleNames.scan, 'resume'),
  COVER_LETTER: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.scan,
    'coverLetter'
  ),
  JOB_DESCRIPTION: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.scan,
    'jobDescription'
  ),
  SHOW_UPLOADER: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.scan,
    'showUploader'
  ),
  SHOW_UPDATE_FORM: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.scan,
    'showUpdateForm'
  ),
  SHOW_EDUCATION_FORM: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.scan,
    'showEducationForm'
  ),
  POWER_EDIT_DATA: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.scan,
    'powerEditData'
  ),
  CURRENT_JD: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.scan,
    'currentJd'
  ),
  CV_TEXT: StoreUtil.prefixModuleKeys(StoreUtil.moduleNames.scan, 'cvText'),
  JD_TEXT: StoreUtil.prefixModuleKeys(StoreUtil.moduleNames.scan, 'jdText'),
  CL_TEXT: StoreUtil.prefixModuleKeys(StoreUtil.moduleNames.scan, 'clText'),
  CONVERSION_ID: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.scan,
    'conversionId'
  ),
  CL_CONVERSION_ID: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.scan,
    'clConversionId'
  ),
}
